import NavGlobal from '../../components/navGlobal/navGlobal';
import NavSection from '../../components/navSection/navSection';
import NavSectionSubnav from '../../components/navSection/navSectionSubnav';

import NavSigninLoader from '../../components/account/NavSigninLoader';

//check if nav exists first
const globalNav = document.getElementById("global-nav");
if(globalNav && !globalNav.classList.contains('navigation-activated')){
	new NavGlobal();
	var navSigninLoader = new NavSigninLoader();
	navSigninLoader.init();

	var topLevel = document.querySelector( '.section-nav .top-level' );

	if( null !== topLevel && topLevel !== undefined ){
	    new NavSection();
	}

	var subNav = document.querySelector( '.section-front-navigation' );

	if( null !== subNav && subNav !== undefined ){
	    new NavSectionSubnav();
	}

	globalNav.classList.add('navigation-activated');
}





// WEBPACK FOOTER //
// ./assets/layouts/base/header.js